var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 45,
    viewBox: "0 0 140 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.983 18.8358V27.4769H108.836V34.0322C108.24 34.3302 106.512 34.9261 104.366 34.9261C101.685 34.9261 96.0234 34.0322 94.2355 27.4769V18.2398C94.5335 15.5581 96.9769 10.1947 104.366 10.1947C105.956 10.1947 109.67 10.9098 111.816 13.7703L118.073 5.72516C115.789 3.54006 109.849 -0.591779 104.366 0.361721C97.4139 -0.135179 83.5087 2.68502 83.5087 17.941V28.072C83.906 33.5347 88.4549 44.4602 103.473 44.4602C106.949 44.5596 114.915 43.6259 118.967 39.0968V18.8358H101.983Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.67334 43.5672V1.25563H21.8291C25.6034 1.85157 33.1519 5.06963 33.1519 13.1744C33.1519 21.2791 28.3844 26.4837 26.0007 28.0728L31.9601 39.0977L45.9646 1.25563H56.3935L70.1001 37.9058V8.40688H80.529L81.1249 43.5672H60.2671L56.9894 36.118H45.3687L42.9849 43.5672L22.4251 44.1631L15.2738 30.7545H11.1022V43.5672H0.67334ZM11.1022 10.4927V21.2195H18.5515C19.8427 20.9216 22.4251 19.4317 22.4251 15.8561C22.4251 12.2805 19.8427 10.7906 18.5515 10.4927H11.1022ZM54.9037 26.583H47.4544L51.0301 14.9622L54.9037 26.583Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.529 3.69848V2.90869H126.678V3.69848H125.071V8.1096H124.136V3.69848H122.529Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.478 2.90869H128.631L130.175 6.67732H130.236L131.78 2.90869H132.933V8.1096H132.029V4.53652H131.981L130.543 8.09436H129.868L128.431 4.5289H128.382V8.1096H127.478V2.90869Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.526 35.8193C139.526 40.5917 135.657 44.4604 130.885 44.4604C126.112 44.4604 122.244 40.5917 122.244 35.8193C122.244 31.047 126.112 27.1782 130.885 27.1782C135.657 27.1782 139.526 31.047 139.526 35.8193Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaig);
export default __webpack_public_path__ + "static/media/raig.4acd6a630e51085177cacf76cf15ccef.svg";
export { ForwardRef as ReactComponent };